<template>
  <div class="cross-project-setting">
    <basiCcontainer>
      <template #head>
        <Banner></Banner>
      </template>
      <commonTable tableHead="projectSettingCross" :config="config" :apiUrl="{url:'home',methods:'managementIndex'}" ref="commonTable" :params="ruleForm" :selection="false" :tipShow="false" :verifyRemark="true" :popover="false" :verifyWidth="200">
        <template #table_head>
          <div class="project-sethead">
            <el-input class="earch-input" style="margin-right:20px;" prefix-icon="icon iconfont iconicon_search1" size="mini" placeholder="搜索项目名称" clearable v-model="ruleForm.keyword" @input="debounce(init,500)">
            </el-input>
            <el-select size="mini" v-model="ruleForm.project_status" placeholder="请选择" @change="init">
              <el-option v-for="(item, index) in optionstype" :key="item" :label="item" :value="index + 1">
              </el-option>
            </el-select>
            <span class="tip">共{{$refs.commonTable ? $refs.commonTable.ruleForm.pagData.total : 0}}个项目</span>
          </div>
        </template>
        <!-- <template slot="title" slot-scope="scope">
          <p class="tags-tip" @click="$router.push(`/task?projectId=${scope.data.project_id}&isTabShow=true`)">{{scope.data.title}}</p>
        </template> -->
        <template slot="create_time" slot-scope="scope">
          <span>{{scope.data.create_time.replace(/-/g,'/')}}</span>
        </template>
        <template slot="verifyRemark" slot-scope="scope">
          <span class="add-btn" v-if="ruleForm.project_status === 1" @click="addProject(scope.data)">进入</span>
          <span class="add-btn" v-else-if="ruleForm.project_status !== 1" @click="activeProject(scope.data)">激活</span>
        </template>
      </commonTable>
    </basiCcontainer>
  </div>
</template>
<script>
import api from '@/services/api/home/home'
import { mapState, mapMutations } from 'vuex'
import Banner from '@/components/banner'
export default {
  components: {
    Banner
  },
  data() {
    return {
      options: [],
      optionstype: ['活跃中', '已冻结', '已归档', '已删除'],
      config: {
        setCellStyle: () => true,
        page: 'per_page'
      },
      filterText: '',
      disabled: false,
      timer: null,
      ruleForm: {
        project_status: 1,
        keyword: ''
      }
    }
  },
  created() {
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.$refs.commonTable.getTableList()
    },
    //防抖函数
    debounce(fn, wait) {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(fn, wait)
    },
    async addProject(data) {
      this.$router.push(`/main/myProject/crossProjectDetail?id=${data.id}`)
    },
    async activeProject(data) {
      await this.$wfAlert('', '确定激活此项目吗？', '', '确定')
      api.updateCrossProjectStatus({
        id: data.id,
        project_status: 1
      }).then(() => {
        this.init()
      })
    }
  }
}
</script>
<style lang="scss" >
.cross-project-setting {
  .nedd-post {
    padding: 0 40px;
  }
  .project-sethead {
    padding: 8px;
    display: flex;
    align-items: center;
    margin-top: 16px;
    .tip {
      font-size: 12px;
      color: #9d9fb3;
      margin-left: 20px;
    }
  }
  .earch-input {
    width: 200px;
  }
  .add-btn {
    cursor: pointer;
    color: $color-active;
    margin: 0 17px;
  }
  .add-rest {
    color: #9d9fb3;
    cursor: not-allowed;
  }
}
</style>
